import { Typography, Box } from "@mui/material";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import Image1 from "../../../../../assets/images/operating-manual/4/4.9a.png";
import Image1French from "../../../../../assets/images/operating-manual/4/4.9a-fr.png";
import Image2 from "../../../../../assets/images/operating-manual/4/4.9b.png";
import Image2French from "../../../../../assets/images/operating-manual/4/4.9b-fr.png";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const ExternalExams = () => {
  const { t } = useTranslation();
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);

  const imgAttributes = [
    [Image1, Image1French],
    [Image2, Image2French],
  ];

  return (
    <Box id="external-exams" sx={{ ...sectionContainerStyle, padding: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          background:
            "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
          color: "white",
          p: 1,
          pl: 4,
          borderRadius: 2,
          mb: 2,
          boxShadow: "0px 0.625rem 3rem 0px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Typography variant="h6" fontWeight="600">
          {`5.9. ${t("external_exams")}`}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          pl: 4,
          pr: 4,
          gap: 2,
        }}
      >
        <Typography sx={{ color: "text.primary", flex: 1 }}>
          {`${t("operating_manual_external_exam_description1")}`}
        </Typography>
        <Box sx={{ ...sectionContainerStyle, mt: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 1,
            }}
          >
            <Typography sx={{ color: "text.primary", flex: 1 }}>
              {`1. ${t("operating_manual_external_exam_description1_1")}`}
            </Typography>

            <Box
              component="img"
              src={imgAttributes[0][t("operating_manual_image_index")]}
              alt="Description Image"
              sx={{
                width: "80%",
                height: "auto",
                my: 2,
                borderRadius: 1,
              }}
            />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "text.primary" }}>
              {`2. ${t("operating_manual_external_exam_description1_2")}`}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "text.primary", flex: 1 }}>
              {`3. ${t("operating_manual_external_exam_description1_3")}`}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 1,
            }}
          >
            <Typography
              sx={{ display: "flex", alignItems: "center", mt: 1, mb: 2 }}
            >
              {`4. ${t("operating_manual_external_exam_description1_4")}`}
            </Typography>
            <Box
              component="img"
              src={imgAttributes[1][t("operating_manual_image_index")]}
              alt="Description Image"
              sx={{
                width: "80%",
                height: "auto",
                my: 2,
                borderRadius: 1,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExternalExams;
